<template>
  <section>
    <div class="animated fadeIn h-100">
      <!-- <b-card class="h-30">
        <div class="card-body"> -->
          <h6>Please confirm the part information and click "Receive" to receive the item</h6>
					<br/>
					<b-row v-if="isconsignmentExist">
						<b-col cols="2">
							<dt>Receiving Part</dt>
							<dd>{{ consignmentObj.partNumber }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Comments</dt>
							<dd>{{ consignmentObj.comments }}</dd>
						</b-col>
					</b-row>
        </div>
        <br/>
        <div>
          <consignment-receive-details
							:receiveDetailsArr="receiveFormDetailsArr"
							:lineReceiveObj="lineReceiveObj"
							:consignment="consignmentObj"
							@receiveInput="setReceiveDetails"
							@quantityChange="onQuantityChange($event)"
					/>
        </div>
        <br/>
        <b-row>
					<b-col>
            <div></div>
						<div class="buttons-panel">
							<b-button size="sm" variant="outline-danger" class="mr-1" @click="redirectToList">Cancel</b-button>
							<b-button size="sm" class="mr-1" @click="handleClear">Clear</b-button>
							<b-button variant="primary" size="sm" class="mr-1" @click="receiveItemDetails(false)" :disabled="isSaving">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Receive</b-button>
							<b-button variant="primary" size="sm" @click="receiveItemDetails(true)" :disabled="isSaving">
                <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save & Close</b-button>
						</div>
					</b-col>
				</b-row>
      <!-- </div>
     </b-card> -->
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import ConsignmentReceiveDetails from './receiveDetails';

export default {
  components: {
    ConsignmentReceiveDetails
  },
  props: {
    consignmentId: {
      type: [Number, String],
      default: 0
    },
    consignmentObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      headerObj: {
				pageTitle: 'Receive Consignment Item',
				contactFullName: '',
				dateValue: '',
				statusName: ''
      },
      receiveFormDetailsArr: [],
      lineReceiveObj: {},
      isSaving: false,
    }
  },
  computed: {
    isconsignmentExist() {
      return Object.keys(this.consignmentObj).length > 0;
    },
    sumReceiveQuantity() {
			return this.receiveFormDetailsArr.map(details => details.quantity).reduce((a, b) => a + b);
		},
  },
  methods: {
    ...mapActions('consignments', ['receiveConsignment']),
    setReceiveDetails() {
			this.receiveFormDetailsArr = [];

			if (this.isconsignmentExist && this.lineReceiveObj.received > 0) {
				let receiveDetailObj = this.readyMadeReceiveDetailObj();

				receiveDetailObj.quantity = this.lineReceiveObj.received;

				this.receiveFormDetailsArr.push(receiveDetailObj);
				this.lineReceiveObj.showDetails = true;
			} else {
				this.lineReceiveObj.showDetails = false;
			}
    },
    onQuantityChange(val) {
			let received = parseInt(this.lineReceiveObj.received, 10);;
			console.log(this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == 0, this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity, val, isNaN(val))
			if (this.sumReceiveQuantity < received && this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity > 0) {
				this.receiveFormDetailsArr.push(this.readyMadeReceiveDetailObj());
			} else if (this.sumReceiveQuantity === received
				&& (this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == 0 || this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == null)) {
				this.receiveFormDetailsArr.pop();
			} else if ((val == 0 || isNaN(val)) && this.receiveFormDetailsArr[this.receiveFormDetailsArr.length - 1].quantity == null && this.receiveFormDetailsArr.length != 1) {
				this.receiveFormDetailsArr.pop();
			}
		},
    readyMadeReceiveDetailObj() {
			return {
				id: 0,
				quantity: null,
				rejected: false,
				test: false,
				repack: false,
				cost: 0,
				dateCode: null,
				lotCode: null,
				revision: null,
				conditionId: 0,
				countryOfOriginId: 0,
				vrmaReasonId: 0,
				comments: null,
				warehouseId: 0,
				location: null,
				isSplit: false,
				inventorySplits: [],
				images: []
			};
    },
    readyMadeLineReceiveObj() {
			return {
				received: 0,
				showDetails: false
			}
    },
    redirectToList() {
			this.$emit('onRedirectToList');
    },
    handleClear() {
			this.receiveFormDetailsArr = [];
			this.lineReceiveObj = this.readyMadeLineReceiveObj();
    },
    isValidLines(lines) {
			let isValid = true;

			for (let i = 0; i < lines.length; i++) {
				isValid = lines[i].quantity != ""
					&& lines[i].cost != ""
					&& lines[i].conditionId != 0
					&& lines[i].countryOfOriginId != 0
					&& lines[i].warehouseId != 0
					&& lines[i].location != null
			}

			return isValid;
		},
    async receiveItemDetails(isToRedirect) {
			let tempReceiveArr = this.receiveFormDetailsArr;

			// Auto disregards the newly added last row...
			if (tempReceiveArr.length > 1
				&& tempReceiveArr[tempReceiveArr.length -1].quantity == null) {
				tempReceiveArr.pop();
			}

			if (tempReceiveArr.length > 0 && !this.isValidLines(tempReceiveArr)) {
				alert("Please populate required fields.");
				return;
			}

			this.$snotify.info('Receiving in progress', 'Receive Consignment');

			const receiveData = {
				...this.lineReceiveObj,
				consignmentId: this.consignmentObj.id,
				lines: tempReceiveArr
			}
			try {
        this.isSaving = true;
        const result = await this.receiveConsignment(receiveData);
        this.isSaving = false;
        if (result.status == 200) {
          this.$snotify.success('Receiving Saved', 'Receive Consignment');
          // this.lineReceiveObj.received = 0;
          // this.lineReceiveObj.showDetails = false;
        }

        if (isToRedirect) {
          this.redirectToList();
        }
      }catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
		},
  },
  async mounted() {
    this.handleClear();
  }
}
</script>
